import {WretchError, ApiError} from '@treatwell/ui';

export const errorCatcher = (error: WretchError) => {
  throw new ApiError(error);
};
